import styled from 'styled-components';
import React from 'react';
import { SectionParent, BlueButton, B1 } from '../../StyledComponents';
import Arrow from '../../../assets/v2/homepagedevsection/arrow.svg';
import NewsHero from '../../../assets/v2/News/NewsHero.svg';
import NewsBg from '../../../assets/v2/News/NewsBg.svg';
import { navigate, StaticQuery, graphql } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOneTitle = styled(Title)`
  color: #ffffff;
  margin-bottom: 0.4rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const Section = styled(SectionParent)`
  display: grid;
  padding-top: 5rem !important;
  position: relative;
  z-index: 0;
  padding-bottom: 0rem !important;
  display: grid;
  /* padding: 0rem 25rem; */
  /* grid-template-columns: repeat(14, 1fr); */
  /* background: #1b2341; */
  background-image: linear-gradient(to bottom, #262e5c, #262e5c 47%, #232a57);
`;

const SectionTwo = styled(SectionParent)`
  display: grid;
  padding-top: 3rem !important;
  padding-bottom: 1.5rem !important;
  position: relative;
  z-index: 0;
  display: grid;
  min-height: 300px;
  /* padding: 0rem 25rem; */
  /* grid-template-columns: repeat(14, 1fr); */
  background: #151a2e;
`;

const SolutionsContent = styled.div`
  grid-column: span 7;
  display: grid;
  background: url(${NewsBg});
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 4rem;
  @media (max-width: 768px) {
    grid-column: span 14;
    padding-bottom: 2rem;
    padding-left: 0;
  }
  @media (max-width: 520px) {
    grid-column: span 14;
    padding-left: 0;
  }
`;
const FromManufacturingT = styled.h2`
  font-size: 18px;
  line-height: 31px;
  color: #9fc2ff;
  text-align: center;
  width: 50%;
  margin-left: 25%;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  margin-bottom: 0rem;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 100%;
    padding: 0 2rem;
    line-height: 1.5;
    margin-left: 0;
  }
`;

const EsperManagePage = styled.div`
  padding-top: 4rem;
  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`;

const HeroImgContainerLeft = styled.img`
  width: 20%;
  height: auto;
  justify-self: center;
  @media (max-width: 520px) {
    width: 40%;
  }
`;
const HeroImgContainer = styled.div`
  display: grid;
  padding: 0rem;
`;
class NewsSectionOne extends React.PureComponent<any, any> {
  render() {
    return (
      <div style={{ position: 'relative' }}>
        <Section>
          <SolutionsContent>
            <EsperManagePage>
              {/* <EsperManageSubHeading>ESPER MANAGE</EsperManageSubHeading> */}

              <HeroImgContainer>
                <HeroImgContainerLeft alt="Esper Developer" src={NewsHero} />
              </HeroImgContainer>
              <SectionOneTitle
                style={{
                  textAlign: 'center',
                }}
              >
                Esper In The News
              </SectionOneTitle>
              <FromManufacturingT>
                Stories about Esper that we especially love
              </FromManufacturingT>
            </EsperManagePage>
          </SolutionsContent>
        </Section>
      </div>
    );
  }
}
export default NewsSectionOne;
